import service from '@/utils/request'

export async function getLogicCheck(userId: number, gameId: number) {
  const resp = await service.get('/api/record_log/logic_check', {
    params: { user_id: userId, game_id: gameId }
  })
  return resp.data
}
